// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:errors` (see frontend/package.json).
// Source: agent.shared.types.repository.IdentityRequiredError

import { RpcError, registerRpcError } from "@/app_store/rpc_error";

// Wire shape of this error: `code` discriminates the type, `message` is the
// human-readable text, and the remaining keys are the exception's own fields.
export interface IdentityRequiredErrorData {
    code: "IdentityRequiredError";
    message: string;
}

export class IdentityRequiredError extends RpcError {
    readonly code = "IdentityRequiredError" as const;

    constructor(data: IdentityRequiredErrorData) {
        super(data.code, data.message, data);
    }
}

registerRpcError("IdentityRequiredError", IdentityRequiredError);
